<script setup lang="ts">
import NoteComponent from '~/components/NoteComponent.vue'
import type { Coverage, PaymentInfo } from '~/layers/forms/models'

interface Props {
  modelValue: PaymentInfo
  coverage: Coverage
}

const props = defineProps<Props>()
const model = useVModel(props, 'modelValue')
//const emits = defineEmits(['update:modelValue', 'pay'])

const { RemoteConfigurationStore } = stores()

const { getTodayPayment, discountIsValid } = useCoveragePaymentSumary({
  amount: computed(() => props.coverage.grandTotal),
  discount: computed(() => model.value),
  argentoInsurancePaymentCondition: computed(
    () =>
      props.coverage.argentoInsuranceAplicablePaymentConditions?.find(
        (aiapc) => aiapc.condicionPagoId === model.value.argentoInsurancePaymentConditionId
      )?.condicionPago
  ),
  argentoInsuranceCalculatedPaymentConditions: computed(() =>
    props.coverage.argentoInsuranceAplicableCalculatedPaymentConditions?.find(
      (aiapc) => aiapc.condicionPagoId === model.value.argentoInsurancePaymentConditionId
    )
  ),
})
</script>

<template>
  <div class="flex flex-col gap-4">
    <FormsPaymentInfoForm
      v-model="model"
      :coverage="coverage"
    />
    <NoteComponent
      v-if="RemoteConfigurationStore?.ramoEnum === 'Auto'"
      message="Este pago será retenido hasta la aceptación del vehículo por parte de la aseguradora. Si se
      declina, el hold será devuelto al método de pago en un plazo no máximo a 7 días laborables
      posterior al hold."
    />

    <template v-if="getTodayPayment()">
      <hr class="col-span-full border-primary-100/20" />
      <div class="flex flex-col justify-center gap-2">
        <span class="text-2xl font-bold uppercase text-center">Monto a pagar hoy</span>

        <CardComponent
          bg="light"
          class="text-center"
        >
          <div class="text-4xl font-bold">
            RD$
            {{
              formatCurrency({
                price: getTodayPayment({ applyDiscount: discountIsValid }),
              })
            }}
          </div>
          <div
            v-if="discountIsValid"
            class="text-lg text-red-400 line-through"
          >
            RD$
            {{
              formatCurrency({
                price: getTodayPayment(),
              })
            }}
          </div>
        </CardComponent>
      </div>
    </template>
    <!--
    <hr class="col-span-full border-primary-100/20" />
     <PvButton
      severity="success"
      class="col-span-full"
      @click="pay"
    >
      <span class="flex items-center gap-2 py-2 text-xl font-bold uppercase md:text-2xl">
        <span class="icon-[ph--shield-check-bold]" />
        Finalizar
      </span>
    </PvButton> -->
  </div>
</template>
